import { APPS } from '@squirrellearningltd/go-shared-utils';

export const APP_NAME = APPS.go_portal_pupil;
export const APP_NAME_US = APPS.boom_math_portal_pupil;

export const SURVEY_STATUS = {
    new: 0,
    stated: 1,
    completed: 2,
};
